import { render } from "./FormCard.vue?vue&type=template&id=4870c42a&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"

import "./FormCard.vue?vue&type=style&index=0&id=4870c42a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4870c42a"]])

export default __exports__